import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonPopoverV2 } from './PopoverV2.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonPopoverV2({ prefix }));
}
